import React from 'react';

import Hero from '../components/Hero';
import CardGrid from '../components/CardGrid';
import ResourceCard from '../components/ResourceCard';
import Section from '../components/Section';

const DefaultIndexTemplate = ({ pageContext: { page, entries } }) => (
  <Section>
    <Hero {...page} />
    <CardGrid entries={entries} Component={ResourceCard} {...page} />
  </Section>
);

export default DefaultIndexTemplate;
